import { Redirect, Route, RouteChildrenProps, Switch } from 'react-router';
import { CreateRulePage } from './pages/CreateRulePage';
import { EditRulePage } from './pages/EditRulePage';
import { LinkedQueuesRulePage } from './pages/LinkedQueuesRulePage';
import { RulesPage } from './pages/RulesPage';
import { ruleManagerPath } from './routes';

export const RuleManagerRoutes = (props: RouteChildrenProps) => {
  const { match } = props;

  if (!match) {
    return null;
  }

  return (
    <Switch>
      <Route path={ruleManagerPath()} exact component={RulesPage} />
      <Route
        path={`${ruleManagerPath()}/new`}
        exact
        component={CreateRulePage}
      />
      <Route
        path={`${ruleManagerPath()}/:ruleId/detail`}
        exact
        component={EditRulePage}
      />
      <Route
        path={`${ruleManagerPath()}/:ruleId/queues`}
        exact
        component={LinkedQueuesRulePage}
      />
      <Route path={`${ruleManagerPath()}/rules`}>
        <Redirect to={ruleManagerPath()} />
      </Route>
    </Switch>
  );
};
